import { render, staticRenderFns } from "./TransferOrdersInt.vue?vue&type=template&id=21539ed0"
import script from "./TransferOrdersInt.vue?vue&type=script&lang=js"
export * from "./TransferOrdersInt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports